<template>
    <Modal :title="patientLabel(patient.ticPrefix, patient.ticNumber)" @close="close" :closeOnClickOutside="false">

        <div class="hpo-patient-modal">
            <TriageTab v-if="activeTab === PatientModalTabs.TIC"
                          :hpoId="hpoId"
                          v-model:patient="patient"
                          @setActiveTab="handleSetActiveTab"
                          @close="close"/>

            <TransportTab v-else-if="activeTab === PatientModalTabs.TRANSPORT"
                          :hpoId="hpoId"
                          :patient="patient"
                          @setActiveTab="handleSetActiveTab"
                          @submitTransport="handleSubmitTransport"
                          @close="close"/>

            <IdentificationTab v-else-if="activeTab === PatientModalTabs.IDENTIFICATION"
                               :hpoId="hpoId"
                               :patientData="data"
                               :countries="countries"
                               :member="member"
                               @close="close"/>
            <HospitalRecordsTab v-else-if="activeTab === PatientModalTabs.HOSPITAL_RECORDS"
                                :patientData="data"
                                @close="close"/>
            <ImageTab v-else-if="activeTab === PatientModalTabs.IMAGES"
                      :patient="patient"
                      @close="close"/>

        </div>
    </Modal>
</template>

<script>
import Modal from "@/components/modal/Modal";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import {useMutation} from "@vue/apollo-composable";
import {UnitType} from "@/choices";


import {HpoPatientList} from "@/graphql/queries/hpo/patients.graphql"
import {ref} from "vue";
import Dropdown from "@/components/forms/Dropdown";

import NewFormGroup from "@/components/forms/NewFormGroup"
import RadioGroup from "@/components/forms/RadioGroup";
import {YesNo} from "../../../choices";
import {oneOfNumberValidator, requiredMessage, stringValidator} from "@/utils/yupValidators";

import TransportTab from "./tabs/TransportTab.vue";
import IdentificationTab from "./tabs/IdentificationTab.vue";
import {HospitalType, PatientModalTabs, WORKPLACE_TYPE} from "../choices";
import TriageTab from "./tabs/TriageTab.vue";
import {HpoPatientTransportMutation} from "@/graphql/mutations/hpo/patient/transport.graphql";
import {patientLabel} from "./utils";
import {
    hospitalRecordsTabAccess,
    identificationTabAccess,
    triageTabAccess,
    transportTabAccess,
} from "./tabs/tabsAccess";
import HospitalRecordsTab from "./tabs/HospitalRecordsTab.vue";
import ImageTab from "@/components/hpo/patientModal/tabs/ImageTab.vue";


export default {
    name: "HpoPatientModal",
    components: {
        ImageTab,
        Modal,
        Form,
        Field,
        ErrorMessage,
        NewFormGroup,
        Dropdown,
        RadioGroup,
        TransportTab,
        IdentificationTab,
        TriageTab,
        HospitalRecordsTab,
    },
    emits: ['close', 'submitTransport'],
    props: {
        hpoId: {
            type: String,
            require: true,
        },
        data: {
            type: Object,
            required: false,
            default: null,
        },
        countries: {
            type: Array,
            required: true
        },
        member: {
            type: Object,
            required: true
        },
    },
    setup(props) {
        const activeTab = ref(props.data.activeTab)
        // let transportData = {
        //     diagnose: null,
        //     ventilated: null,
        //     unitType: null,
        //     unitTypeSpec: null,
        //     callSign: 'ZPM',
        //     hospitalType: null,
        // }

        const patient = ref({...props.data.patient})

        const transportButtonPressed = ref(false)

        const schema = ref(yup.object({
            diagnose: stringValidator.required(requiredMessage),
            ventilated: oneOfNumberValidator(YesNo),
            unitType: oneOfNumberValidator(UnitType),
            unitTypeSpec: yup.string().nullable().when('unitType', {
                is: (val) => val === UnitType.OTHER,
                then: () => stringValidator.required(requiredMessage)
            }),
            callSign: stringValidator.required(requiredMessage),
            hospitalType: stringValidator.oneOf(Object.values(HospitalType)).required(requiredMessage),
        }))


        const {mutate: hpoPatientTransportMutation} = useMutation(HpoPatientTransportMutation, {
            update: (cache, {data: {hpoPatientTransportMutation}}) => {
                const patient = hpoPatientTransportMutation.hpoPatient;
                const variables = {hpoId: props.hpoId, cardPrefix: 'P', cardNumber: ''}
                const queryData = cache.readQuery({query: HpoPatientList, variables: variables});
                if (!queryData.hpoPatientList.some((item) => item.id === patient.id)) {
                    if (queryData && patient) {
                        // Make copy because original data is read-only
                        let updatedList = [...queryData.hpoPatientList]
                        updatedList.unshift(patient)
                        const data = {
                            ...queryData,
                            hpoPatientList: updatedList
                        }
                        cache.writeQuery({query: HpoPatientList, data, variables: variables});
                    }
                }

            }
        });


        return {
            // Imports
            patientLabel,
            triageTabAccess,
            transportTabAccess,
            identificationTabAccess,
            hospitalRecordsTabAccess,
            PatientModalTabs,
            activeTab,
            schema,
            patient,
            hpoPatientTransportMutation,
            transportButtonPressed,
            WORKPLACE_TYPE,

        }

    },
    computed: {},
    methods: {
        submit(values) {
            debugger
        },
        close() {
            this.$emit('close')
        },
        handleSetPatientData(data) {
            this.data = data
        },
        handleSetActiveTab(value) {
            this.activeTab = value
        },
        handleSubmitTransport() {
            this.$emit('submitTransport')
        },
    }
}
</script>